import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import constants from '../../../constants';
import routes from '../../../../../components/Routes/routingMap';
import { Creators as procedureActions } from '../../../../../../domain/useCases/procedures/getProcedureInformation';
import { Creators as activatePaymentActions } from '../../../../../../domain/useCases/procedures/certificateType01/activatePaymentUseCase';
import { Creators as requestStatusActions } from '../../../../../../domain/useCases/procedures/getStudentProcedureStatus';
import { Creators as cancelRequestActions } from '../../../../../../domain/useCases/procedures/UpdatePhoto/cancelUseCase';
import { Creators as paymentsStatusVerificationActions } from '../../../../../../domain/useCases/procedures/certificateType01/paymentsStatusVerificationUseCase';
import ViewProgress from './views/Progress';
import CancelProcedure from './dialogs/CancelProcedure';
import ButtonCancelRequest from '../../../../../components/ButtonCancelRequest';
import { ContainerBtnCancel } from './views/styled';
import useTitle from '@/presentation/hooks/useTitle';
import ErrorProcess from './dialogs/ErrorProcess';
import Back from '@/presentation/reusables/Button/Back';
import ModuleContainer from '@/presentation/components/Container';

const CertificateOfStudiesProgressViewController = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    procedure,
    request,
    isLoading: isLoadingProcedureStudentStatus,
    error: procedureError
  } = useSelector((state: any) => state.procedureStudentStatus);

  const { data: paymentsStatus, isLoading: isLoadingPaymentsStatus } =
    useSelector((state: any) => state.paymentsStatusVerification);

  const isLoadViewBtnCancel =
    Boolean(isLoadingPaymentsStatus) ||
    Boolean(isLoadingProcedureStudentStatus);

  const [shouldCancel, setShouldCancel] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [currentStepPayment, setCurrentStepPayment] = useState(0);
  const [showModalCancelProcedure, setShowModalCancelProcedure] =
    useState(false);
  const [showModalErrorProcessProcedure, setShowModalErrorProcessProcedure] =
    useState(false);

  const { procedure: procedureSelected } = useSelector(
    (state: any) => state.procedureInformation
  );

  const {
    isLoading: isLoadingActivatePayment,
    isSuccess: isSuccessActivatePayment
  } = useSelector((state: any) => state.activatePaymentCertificateType01);

  const { isLoading: isLoadingRegister } = useSelector(
    (state: any) => state.registerCertificateType01
  );

  const { isLoading: isLoadingCancel, isSuccess: isSuccessCancel } =
    useSelector((state: any) => state.cancelUpdatePhoto);

  useEffect(() => {
    if (!procedure) {
      setCurrentStep(0);
    } else if (request.status.status === 'CREADO') {
      setCurrentStep(1);
    } else if (request.status.status === 'PAGO_ACTIVADO') {
      setCurrentStep(1);
      setCurrentStepPayment(1);
    } else if (request.status.status === 'PAGO_REALIZADO') {
      setCurrentStep(2);
    } else if (request.status.status === 'FINALIZADO') {
      if (request?.expiredFile) setCurrentStep(4);
      else setCurrentStep(3);
    }
  }, [procedure, request]);

  const handlerActivatePayment = () => {
    dispatch(
      activatePaymentActions.activateCertificateOfStudies(
        request.procedureId,
        request.id
      )
    );
  };

  useEffect(() => {
    if (isSuccessActivatePayment) {
      dispatch(
        requestStatusActions.getStudentProcedureStatus(
          request?.procedureId,
          request?.id
        )
      );
    }
  }, [isSuccessActivatePayment]);

  const handlerClearActivatePayment = () => {
    dispatch(activatePaymentActions.activateCertificateOfStudiesClear());
  };

  const handlerBack = () => {
    handlerClearActivatePayment();
    history.push(routes.student.procedures.home);
  };

  const handlerCancelRequest = (
    requestIdParam: number,
    procedureIdParam: number
  ) => {
    dispatch(
      cancelRequestActions.cancelUpdatePhoto(requestIdParam, procedureIdParam)
    );
  };

  const handlerStatusPaymentsVerification = (isCancel?: boolean) => {
    dispatch(
      paymentsStatusVerificationActions.paymentsVerificationProcedure(
        request.id
      )
    );
    if (isCancel) setShouldCancel(true);
  };

  useEffect(() => {
    if (!procedureSelected) {
      dispatch(
        procedureActions.getProcedureInformation(
          constants.categories.requests.procedures.certificateOfStudies
        )
      );
    }
  }, []);

  useEffect(() => {
    if (
      shouldCancel &&
      paymentsStatus === constants.paymentsStatusVerification.pending
    ) {
      handlerCancelRequest(request.id, request.procedureId);
      setShouldCancel(false);
    }
    setShowModalCancelProcedure(false);
  }, [paymentsStatus, shouldCancel]);

  useEffect(() => {
    if (isSuccessCancel) {
      history.push('/tramites');
    }
  }, [isSuccessCancel]);
  useTitle('Certificado de estudios progreso');

  useEffect(() => {
    if (request?.status?.name === 'Procede') {
      history.push(
        `${
          routes.student.procedures.categories.requests.certificateOfStudies
            .procedureprogress
        }${'?status=finalizado'}`
      );
    }
    if (request?.status?.name === 'No procede') {
      history.push(
        `${
          routes.student.procedures.categories.requests.certificateOfStudies
            .procedureprogress
        }${'?status=Finalizadonoprocede'}`
      );
    }
    if (request?.id) {
      handlerStatusPaymentsVerification();
    }
  }, [request]);

  return (
    <>
      <ModuleContainer
        containerType="subsection"
        data-testid="cmp-CertificateOfStudiesInfoViewController"
      >
        <div style={{ paddingTop: 16, paddingBottom: 12 }}>
          <Back dataTestid="cmp-buttom-back-refactor" onClick={handlerBack} />
        </div>
        <ViewProgress
          data={procedureSelected}
          request={request}
          step={currentStep}
          activatePayment={handlerActivatePayment}
          isLoadingActivatePayment={
            isLoadingActivatePayment ||
            isLoadingPaymentsStatus ||
            isLoadingRegister ||
            isLoadingCancel
          }
          isSuccessActivatePayment={isSuccessActivatePayment}
          stepPaymentOption={currentStepPayment}
          clearActivatePayment={handlerClearActivatePayment}
          periodsSelectedData={procedure?.detail?.periodDesc}
          isLoadingProcedureStudentStatus={isLoadingProcedureStudentStatus}
          procedureDetail={procedure?.detail}
          stepsCurrent={procedure?.steps}
          hasError={procedureError}
        />
        {['CREADO', 'PAGO_ACTIVADO'].includes(request?.status?.status) &&
          paymentsStatus === constants.paymentsStatusVerification.pending &&
          !isLoadViewBtnCancel && (
            <ContainerBtnCancel>
              <ButtonCancelRequest
                handlerShowAnulate={() => setShowModalCancelProcedure(true)}
              />
            </ContainerBtnCancel>
          )}
      </ModuleContainer>
      <CancelProcedure
        show={showModalCancelProcedure}
        messageInfo={
          request?.status?.status === 'PAGO_ACTIVADO'
            ? 'Este proceso puede tardar hasta 5 minutos en actualizarse en tus pagos pendientes.'
            : undefined
        }
        handlerClose={() => setShowModalCancelProcedure(false)}
        handlerCancelProcedure={() => handlerStatusPaymentsVerification(true)}
      />
      <ErrorProcess
        show={showModalErrorProcessProcedure}
        handlerClose={() => setShowModalErrorProcessProcedure(false)}
      />
    </>
  );
};

export default CertificateOfStudiesProgressViewController;
